var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.156,
    height: 15.156,
    viewBox: "0 0 15.156 15.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10521",
    "data-name": "Group 10521",
    transform: "translate(-9.436 -9.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10522",
    "data-name": "Group 10522",
    transform: "translate(9.436 9.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28883",
    "data-name": "Path 28883",
    d: "M17.461,3.294a1.646,1.646,0,0,0-2.352,0L10.377,8.025,5.646,3.294A1.663,1.663,0,0,0,3.294,5.646l4.731,4.731L3.294,15.108a1.663,1.663,0,0,0,2.352,2.352l4.731-4.731,4.731,4.731a1.663,1.663,0,0,0,2.352-2.352l-4.731-4.731,4.731-4.731a1.646,1.646,0,0,0,0-2.352",
    transform: "translate(-2.799 -2.799)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.d00fb97df8e13048719a3d5627895b1d.svg";
export { ForwardRef as ReactComponent };